import React from 'react';

const DrivetrainFilterIcon = (props) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect x="3.75" y="8.25" width="4.5" height="1.5" rx="0.75" transform="rotate(-90 3.75 8.25)" strokeWidth="1.5" />
      <rect
        x="3.75"
        y="20.25"
        width="4.5"
        height="1.5"
        rx="0.75"
        transform="rotate(-90 3.75 20.25)"
        strokeWidth="1.5"
      />
      <rect
        x="18.75"
        y="8.25"
        width="4.5"
        height="1.5"
        rx="0.75"
        transform="rotate(-90 18.75 8.25)"
        strokeWidth="1.5"
      />
      <rect
        x="18.75"
        y="20.25"
        width="4.5"
        height="1.5"
        rx="0.75"
        transform="rotate(-90 18.75 20.25)"
        strokeWidth="1.5"
      />
      <line x1="6" y1="18.1" x2="18" y2="18.1" strokeWidth="1.8" />
      <line x1="6" y1="6.1" x2="18" y2="6.1" strokeWidth="1.8" />
      <line x1="12.3857" y1="18" x2="12.3857" y2="7" strokeWidth="1.8" />
    </svg>
  );
};
export default DrivetrainFilterIcon;
